<template>
  <v-app class="bckgrnd">
    <!-- <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon color="#64f5a9" size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs> -->

    <v-card class="form-container" style="border:1px solid">
      <v-card flat  style="background-color:#cfd8dc">
      <v-tabs
      v-model="tab"
      background-color="transparent"
      color="basil"
      grow
    >
    <v-tab>
        <v-badge
        color="orange"
        right
      >
        <span slot="badge">{{ country.length }}</span>
        Country
      </v-badge>
      </v-tab>
      <v-tab>
        <v-badge
        color="red"
        right
      >
        <span slot="badge">{{ university.length }}</span>
        University
      </v-badge>
      </v-tab>
      <v-tab>
        <v-badge
        color="orange"
        right
      >
        <span slot="badge">{{ course.length }}</span>
        Course
      </v-badge>
      </v-tab>
      <v-tab>
        <v-badge
        color="red"
        right
      >
        <span slot="badge">{{ level.length }}</span>
        Level
      </v-badge>
      </v-tab>
      <v-tab>
        <v-badge
        color="orange"
        right
      >
        <span slot="badge">{{ submission.length }}</span>
        Submission Status
      </v-badge>
      </v-tab>
      <v-tab>
        <v-badge
        color="red"
        right
      >
        <span slot="badge">{{ offer.length }}</span>
        Offer Status
      </v-badge>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item style="background-color:white">
         
          <v-card-title>
        <span class="title">
          <v-icon color="primary" size="28">public</v-icon>&nbsp;Country&nbsp;
        </span>
        <v-btn color="primary" depressed to="/createCountry" small class="txt_dec">
          Create
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader1" :items="country" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.countryName }}</td>
          <td class="justify-left layout px-4">
            <v-icon small color="primary" class="mr-1" @click="onEdit1(props.item)">edit</v-icon>
            <v-icon small color="#ffa02e" @click="onDelete1(props.item)">delete</v-icon>
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
      </v-tab-item>

      <v-tab-item style="background-color:white"> 
          <v-card-title>
        <span class="title">
          <v-icon color="primary" size="28">account_balance</v-icon>&nbsp;University&nbsp;
        </span>
        <v-btn color="primary" depressed to="/createUniversity" small class="txt_dec">
          Create
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader2" :items="university" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.universityName }}</td>
          <td class="justify-left layout px-4">
            <v-icon small color="primary" class="mr-1" @click="onEdit2(props.item)">edit</v-icon>
            <v-icon small color="#ffa02e" @click="onDelete2(props.item)">delete</v-icon>
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
      </v-tab-item>

      <v-tab-item style="background-color:white">
          <v-card-title>
        <span class="title">
          <v-icon color="primary" size="28">school</v-icon>&nbsp;Course&nbsp;
        </span>
        <v-btn color="primary" depressed to="/createCourse" small class="txt_dec">
          Create
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader3" :items="course" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.courseName }}</td>
          <td class="justify-left layout px-4">
            <v-icon small color="primary" class="mr-1" @click="onEdit3(props.item)">edit</v-icon>
            <v-icon small color="#ffa02e" @click="onDelete3(props.item)">delete</v-icon>
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
      </v-tab-item>

      <v-tab-item style="background-color:white">
          <v-card-title>
        <span class="title">
          <v-icon color="primary" size="28">layers</v-icon>&nbsp;Level&nbsp;
        </span>
        <v-btn color="primary" depressed to="/createLevel" small class="txt_dec">
          Create
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader4" :items="level" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.levelName }}</td>
          <td class="justify-left layout px-4">
            <v-icon small color="primary" class="mr-1" @click="onEdit4(props.item)">edit</v-icon>
            <v-icon small color="#ffa02e" @click="onDelete4(props.item)">delete</v-icon>
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
      </v-tab-item>

      <v-tab-item style="background-color:white">
          <v-card-title>
        <span class="title">
          <v-icon color="primary" size="28">settings_suggest</v-icon>&nbsp;Submission Status&nbsp;
        </span>
        <v-btn color="primary" depressed to="/createSubmission" small class="txt_dec">
          Create
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader5" :items="submission" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td class="justify-left layout px-4">
            <v-icon small color="primary" class="mr-1" @click="onEdit5(props.item)">edit</v-icon>
            <v-icon small color="#ffa02e" @click="onDelete5(props.item)">delete</v-icon>
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
      </v-tab-item>

      <v-tab-item style="background-color:white">
          <v-card-title>
        <span class="title">
          <v-icon color="primary" size="28">verified</v-icon>&nbsp;Offer Status&nbsp;
        </span>
        <v-btn color="primary" depressed to="/createOffer" small class="txt_dec">
          Create
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader6" :items="offer" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td class="justify-left layout px-4">
            <v-icon small color="primary" class="mr-1" @click="onEdit6(props.item)">edit</v-icon>
            <v-icon small color="#ffa02e" @click="onDelete6(props.item)">delete</v-icon>
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
      </v-tab-item>
    </v-tabs-items>
    </v-card>
    </v-card>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
        tab: null,
      
      country: [],
      university: [],
      course: [],
      level: [],
      submission: [],
      offer: [],
      search: "",
      tableHeader1: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Country Name", value: "countryName" },
        { text: "Action", value: "action" }
      ],
      tableHeader2: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "University Name", value: "universityName" },
        { text: "Action", value: "action" }
      ],
      tableHeader3: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Course Name", value: "courseName" },
        { text: "Action", value: "action" }
      ],
      tableHeader4: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Level Name", value: "levelName" },
        { text: "Action", value: "action" }
      ],
      tableHeader5: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Submission Status", value: "status" },
        { text: "Action", value: "action" }
      ],
      tableHeader6: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Offer Status", value: "status" },
        { text: "Action", value: "action" }
      ],
    };
  },

  methods: {
    getData() {
      this.axios
        .get(config.API + "Countries", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.country = res.data;
          this.$Progress.finish();
          this.getData();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
    getData1() {
      this.axios
        .get(config.API + "Universities", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.university = res.data;
          this.$Progress.finish();
          this.getData1();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
    getData2() {
      this.axios
        .get(config.API + "Courses", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.course = res.data;
          this.$Progress.finish();
          this.getData2();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
    getData3() {
      this.axios
        .get(config.API + "Levels", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.level = res.data;
          this.$Progress.finish();
          this.getData3();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
    getData4() {
      this.axios
        .get(config.API + "SubmissionStatus", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.submission = res.data;
          this.$Progress.finish();
          this.getData4();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
    getData5() {
      this.axios
        .get(config.API + "OfferStatus", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.offer = res.data;
          this.$Progress.finish();
          this.getData5();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
   // :rows-per-page-items="[10,15,20]"
    onDelete1(item) {
      // alert(item.id);
      if (confirm("You want to delete this Country !!")) {
        this.axios
          .delete(config.API + `Countries/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Country deleted successfully");
            //this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    onDelete2(item) {
      // alert(item.id);
      if (confirm("You want to delete this Universty !!")) {
        this.axios
          .delete(config.API + `Universities/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("University deleted successfully");
            //this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    onDelete3(item) {
      // alert(item.id);
      if (confirm("You want to delete this Course !!")) {
        this.axios
          .delete(config.API + `Courses/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Course deleted successfully");
            //this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    onDelete4(item) {
      // alert(item.id);
      if (confirm("You want to delete this Level !!")) {
        this.axios
          .delete(config.API + `Levels/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Level deleted successfully");
            //this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },
    onDelete5(item) {
      // alert(item.id);
      if (confirm("You want to delete this Status !!")) {
        this.axios
          .delete(config.API + `SubmissionStatus/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Deleted successfully");
            //this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },
    onDelete6(item) {
      // alert(item.id);
      if (confirm("You want to delete this Status !!")) {
        this.axios
          .delete(config.API + `OfferStatus/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Deleted successfully");
            //this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    onEdit1(item) {
      this.$router.push(`editCountry/${item.id}`);
    },
    onEdit2(item) {
      this.$router.push(`editUniversity/${item.id}`);
    },
    onEdit3(item) {
      this.$router.push(`editCourse/${item.id}`);
    },
    onEdit4(item) {
      this.$router.push(`editLevel/${item.id}`);
    },
    onEdit5(item) {
      this.$router.push(`editSubmission/${item.id}`);
    },
    onEdit6(item) {
      this.$router.push(`editOffer/${item.id}`);
    },
  },

  mounted() {
    this.getData();
    this.getData1();
    this.getData2();
    this.getData3();
    this.getData4();
    this.getData5();
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
</style>